import React from 'react';
import { useParams } from 'react-router-dom';
import { UpcomingAssignments } from '../../components';

export default function MobileCourseAssignmentsPage(){
  const { courseId } = useParams();
  return (
    <div className="m-screen">
      <h2 className="m-subtitle">Course Assignments</h2>
      <UpcomingAssignments courseEndeavorId={Number(courseId)} defaultStatus="incomplete" />
    </div>
  );
}